var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1979 20.2712H52.2396C53.7642 20.2712 55 21.5071 55 23.0316V53.3962L45.7996 45.7526C45.3041 45.3407 44.6783 45.1149 44.0337 45.1149H21.875C20.3505 45.1149 19.1146 43.8791 19.1146 42.3545V34.0733M41.1979 20.2712V11.9899C41.1979 10.4654 39.9621 9.22949 38.4375 9.22949H8.07292C6.54839 9.22949 5.3125 10.4654 5.3125 11.9899V42.3553L14.513 34.7104C15.0086 34.2988 15.6344 34.0733 16.2787 34.0733H19.1146M41.1979 20.2712V31.3128C41.1979 32.8374 39.9621 34.0733 38.4375 34.0733H19.1146",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1979 20.2712H52.2396C53.7642 20.2712 55 21.5071 55 23.0316V53.3962L45.7996 45.7526C45.3041 45.3407 44.6783 45.1149 44.0337 45.1149H21.875C20.3505 45.1149 19.1146 43.8791 19.1146 42.3545V34.0733M41.1979 20.2712V11.9899C41.1979 10.4654 39.9621 9.22949 38.4375 9.22949H8.07292C6.54839 9.22949 5.3125 10.4654 5.3125 11.9899V42.3553L14.513 34.7104C15.0086 34.2988 15.6344 34.0733 16.2787 34.0733H19.1146M41.1979 20.2712V31.3128C41.1979 32.8374 39.9621 34.0733 38.4375 34.0733H19.1146",
    stroke: "black",
    strokeWidth: 4.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1979 11.9899V20.2712V31.3128C41.1979 32.8374 39.9621 34.0733 38.4375 34.0733H19.1146H16.2787C15.6344 34.0733 15.0086 34.2988 14.513 34.7104L5.3125 42.3553V11.9899C5.3125 10.4654 6.54839 9.22949 8.07292 9.22949H38.4375C39.9621 9.22949 41.1979 10.4654 41.1979 11.9899Z",
    fill: "#3364FA",
    stroke: "#3364FA",
    strokeWidth: 4.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7715 17.124H33.3027",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7715 24.813H22.7856",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.37928a12090a3fcdbca41cfe7379fe1a.svg";
export { ForwardRef as ReactComponent };